import {
  appendMainLine2HiredProducts,
  appendBonusToHiredProducts,
} from "@/sagas/normalizers/usagesNormalizer";
import { getEsimContainerById } from '@/constants/constants';
const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";

export const types = {
  GET_MY_PRODUCTS_BEGINS: "PRODUCTS/GET_MY_PRODUCTS_BEGINS",
  GET_MY_PRODUCTS_SUCCESS: "PRODUCTS/GET_MY_PRODUCTS_SUCCESS",
  GET_MY_PRODUCTS_FAILURE: "PRODUCTS/GET_MY_PRODUCTS_FAILURE",
  GET_MY_PRODUCTS_RESET: "PRODUCTS/GET_MY_PRODUCTS_RESET",

  //GETMYPRODUCTS WITHOUT_CACHE
  GET_MY_PRODUCTS_WITHOUT_CACHE_BEGINS: "PRODUCTS/GET_MY_PRODUCTS_WITHOUT_CACHE_BEGINS",
  GET_MY_PRODUCTS_WITHOUT_CACHE_SUCCESS: "PRODUCTS/GET_MY_PRODUCTS_WITHOUT_CACHE_SUCCESS",
  GET_MY_PRODUCTS_WITHOUT_CACHE_FAILURE: "PRODUCTS/GET_MY_PRODUCTS_WITHOUT_CACHE_FAILURE",
  GET_MY_PRODUCTS_WITHOUT_CACHE_RESET: "PRODUCTS/GET_MY_PRODUCTS_WITHOUT_CACHE_RESET",

  // SET_MAIN_MOBILE_LINE: 'PRODUCTS/SET_MAIN_MOBILE_LINE',
  SET_KIND_CLIENT: "PRODUCTS/SET_KIND_CLIENT",

  // GESTION DE LINEA MOVIL
  GET_MOBILE_CONFIGURATION_STATUS_BEGINS:
    "PRODUCTS/GET_MOBILE_CONFIGURATION_STATUS_BEGINS",
  GET_MOBILE_CONFIGURATION_STATUS_SUCCESS:
    "PRODUCTS/GET_MOBILE_CONFIGURATION_STATUS_SUCCESS",
  GET_MOBILE_CONFIGURATION_STATUS_FAILURE:
    "PRODUCTS/GET_MOBILE_CONFIGURATION_STATUS_FAILURE",
  RESET_MOBILE_CONFIGURATION_STATUS:
    "PRODUCTS/RESET_MOBILE_CONFIGURATION_STATUS",

  // GESTION DE LINEA MOVIL RESTRICCIONES
  GET_MY_LINE_DETAIL_MOBILE_RESTRICTION_STATUS_BEGINS:
    "PRODUCTS/GET_MY_LINE_DETAIL_MOBILE_RESTRICTION_STATUS_BEGINS",
  GET_MY_LINE_DETAIL_MOBILE_RESTRICTION_STATUS_SUCCESS:
    "PRODUCTS/GET_MY_LINE_DETAIL_MOBILE_RESTRICTION_STATUS_SUCCESS",
  GET_MY_LINE_DETAIL_MOBILE_RESTRICTION_STATUS_FAILURE:
    "PRODUCTS/GET_MY_LINE_DETAIL_MOBILE_RESTRICTION_STATUS_FAILURE",
  RESET_MY_LINE_DETAIL_MOBILE_RESTRICTION_STATUS:
    "PRODUCTS/RESET_MY_LINE_DETAIL_MOBILE_RESTRICTION_STATUS",

  // ENVIO GESTION DE LINEA MOVIL
  CHANGE_MOBILE_CONFIGURATION_BEGINS:
    "PRODUCTS/CHANGE_MOBILE_CONFIGURATION_BEGINS",
  CHANGE_MOBILE_CONFIGURATION_SUCCESS:
    "PRODUCTS/CHANGE_MOBILE_CONFIGURATION_SUCCESS",
  CHANGE_MOBILE_CONFIGURATION_FAILURE:
    "PRODUCTS/CHANGE_MOBILE_CONFIGURATION_FAILURE",
  RESET_CHANGE_MOBILE_CONFIGURATION:
    "PRODUCTS/RESET_CHANGE_MOBILE_CONFIGURATION",
  // ENVIO GESTION DE LINEA MOVIL
  GET_MOBILE_RESTRICTION_STATUS_BEGINS:
    "PRODUCTS/GET_MOBILE_RESTRICTION_STATUS_BEGINS",
  GET_MOBILE_RESTRICTION_STATUS_SUCCESS:
    "PRODUCTS/GET_MOBILE_RESTRICTION_STATUS_SUCCESS",
  GET_MOBILE_RESTRICTION_STATUS_FAILURE:
    "PRODUCTS/GET_MOBILE_RESTRICTION_STATUS_FAILURE",
      // GESTIONES PARA MODIFICAR EN CASCADA 
  GET_MOBILE_RESTRICTION_GESTION_STATUS_BEGINS:
  "PRODUCTS/GET_MOBILE_RESTRICTION_GESTION_STATUS_BEGINS",
GET_MOBILE_RESTRICTION_GESTION_STATUS_SUCCESS:
  "PRODUCTS/GET_MOBILE_RESTRICTION_GESTION_STATUS_SUCCESS",
  GET_MOBILE_RESTRICTION_GESTION_STATUS_SUCCESS_UPDATE:
  "PRODUCTS/GET_MOBILE_RESTRICTION_GESTION_STATUS_SUCCESS_UPDATE",
  GET_MOBILE_RESTRICTION_GESTION_MSG_SUCCESS_UPDATE:
  "PRODUCTS/GET_MOBILE_RESTRICTION_GESTION_MSG_SUCCESS_UPDATE",
GET_MOBILE_RESTRICTION_GESTION_STATUS_FAILURE:
  "PRODUCTS/GET_MOBILE_RESTRICTION_GESTION_STATUS_FAILURE",
  RESET_MOBILE_RESTRICTION_STATUS: "PRODUCTS/RESET_MOBILE_RESTRICTION_STATUS",
  RESET_ALL_MOBILE_RESTRICTION_STATUS:
    "PRODUCTS/RESET_ALL_MOBILE_RESTRICTION_STATUS",
  SET_PHONE_TYPE: "PRODUCTS/SET_PHONE_TYPE",
  CHANGE_MOBILE_RESTRICTION_BEGINS: "PRODUCTS/CHANGE_MOBILE_RESTRICTION_BEGINS",
  CHANGE_MOBILE_RESTRICTION_SUCCESS:
    "PRODUCTS/CHANGE_MOBILE_RESTRICTION_SUCCESS",
  CHANGE_MOBILE_RESTRICTION_FAILURE:
    "PRODUCTS/CHANGE_MOBILE_RESTRICTION_FAILURE",
  RESET_CHANGE_MOBILE_RESTRICTION: "PRODUCTS/RESET_CHANGE_MOBILE_RESTRICTION",
  //GESTION LINEAS ROAMING
  CHANGE_MOBILE_RESTRICTION_GESTION_BEGINS: "PRODUCTS/CHANGE_MOBILE_RESTRICTION_GESTION_BEGINS",
  CHANGE_MOBILE_RESTRICTION_GESTION_SUCCESS:
    "PRODUCTS/CHANGE_MOBILE_RESTRICTION_GESTION_SUCCESS",
  CHANGE_MOBILE_RESTRICTION_GESTION_FAILURE:
    "PRODUCTS/CHANGE_MOBILE_RESTRICTION_GESTION_FAILURE",
  RESET_CHANGE_MOBILE_GESTION_RESTRICTION: "PRODUCTS/RESET_CHANGE_MOBILE_GESTION_RESTRICTION",
  // EQUIPMENT
  GET_EQUIPMENT_PRODUCTS: "GET_EQUIPMENT_PRODUCTS",
  GET_EQUIPMENT_PRODUCTS_SUCCESS: "GET_EQUIPMENT_PRODUCTS_SUCCESS",
  // R2R
  GET_MIS_PRODUCTOS_R2R_BEGINS: "PRODUCTS/GET_MIS_PRODUCTOS_R2R_BEGINS",
  GET_MIS_PRODUCTOS_R2R_SUCCESS: "PRODUCTS/GET_MIS_PRODUCTOS_R2R_SUCCESS",
  GET_MIS_PRODUCTOS_R2R_FAILURE: "PRODUCTS/GET_MIS_PRODUCTOS_R2R_FAILURE",
  GET_ALL_PRODUCTOS_R2R_BEGINS: "PRODUCTS/GET_ALL_PRODUCTOS_R2R_BEGINS",
  GET_ALL_PRODUCTOS_R2R_SUCCESS: "PRODUCTS/GET_ALL_PRODUCTOS_R2R_SUCCESS",
  // ACTIVATE LINE
  GET_ACTIVATE_LINE_BEGINS: "PRODUCTS/GET_ACTIVATE_LINE_BEGINS",
  GET_ACTIVATE_LINE_SUCCESS: "PRODUCTS/GET_ACTIVATE_LINE_SUCCESS",
  GET_ACTIVATE_LINE_FAILURE: "PRODUCTS/GET_ACTIVATE_LINE_FAILURE",

  POST_SEGUNDA_FIBRA_DESACTIVAR_BEGINS:
    "PRODUCTS/POST_SEGUNDA_FIBRA_DESACTIVAR_BEGINS",
  POST_SEGUNDA_FIBRA_DESACTIVAR_SUCCESS:
    "PRODUCTS/POST_SEGUNDA_FIBRA_DESACTIVAR_SUCCESS",
  POST_SEGUNDA_FIBRA_DESACTIVAR_ERROR:
    "PRODUCTS/POST_SEGUNDA_FIBRA_DESACTIVAR_ERROR",
  POST_SEGUNDA_FIBRA_DESACTIVAR_RESET:
    "PRODUCTS/POST_SEGUNDA_FIBRA_DESACTIVAR_RESET",

  POST_SEGUNDA_FIBRA_ACTIVAR_BEGINS:
    "PRODUCTS/POST_SEGUNDA_FIBRA_ACTIVAR_BEGINS",
  POST_SEGUNDA_FIBRA_ACTIVAR_SUCCESS:
    "PRODUCTS/POST_SEGUNDA_FIBRA_ACTIVAR_SUCCESS",
  POST_SEGUNDA_FIBRA_ACTIVAR_ERROR: "PRODUCTS/POST_SEGUNDA_FIBRA_ACTIVAR_ERROR",
  POST_SEGUNDA_FIBRA_ACTIVAR_RESET: "PRODUCTS/POST_SEGUNDA_FIBRA_ACTIVAR_RESET",

  GET_SELLING_TYPES_BY_PRODUCT_ID_BEGIN:
    "PRODUCTS/GET_SELLING_TYPES_BY_PRODUCT_ID_BEGIN",
  GET_SELLING_TYPES_BY_PRODUCT_ID_SUCCESS:
    "PRODUCTS/GET_SELLING_TYPES_BY_PRODUCT_ID_SUCCESS",
  GET_SELLING_TYPES_BY_PRODUCT_ID_STATUS:
    "PRODUCTS/GET_SELLING_TYPES_BY_PRODUCT_ID_STATUS",
  GET_SELLING_TYPES_BY_PRODUCT_ID_STATUS_RESET:
    "PRODUCTS/GET_SELLING_TYPES_BY_PRODUCT_ID_STATUS_RESET",

  GET_IMAGES_RENT2RENT: "PRODUCT/GET_IMAGES_RENT2RENT",

  // PUK CODE
  GET_PUK_CODE_BEGINS: 'PRODUCTS/GET_PUK_CODE_BEGINS',
  GET_PUK_CODE_SUCCESS: 'PRODUCTS/GET_PUK_CODE_SUCCESS',
  GET_PUK_CODE_FAILURE: 'PRODUCTS/GET_PUK_CODE_FAILURE',

  // ESIM DOWNLOAD
  GET_ESIM_DOWNLOAD_BEGINS: "PRODUCTS/GET_ESIM_DOWNLOAD_BEGINS",
  GET_ESIM_DOWNLOAD_SUCCESS: "PRODUCTS/GET_ESIM_DOWNLOAD_SUCCESS",
  GET_ESIM_DOWNLOAD_FAILURE: "PRODUCTS/GET_ESIM_DOWNLOAD_FAILURE",

  // ESIM STATUS
  GET_ESIM_STATUS_BEGINS: "PRODUCTS/GET_ESIM_STATUS_BEGINS",
  GET_ESIM_STATUS_SUCCESS: "PRODUCTS/GET_ESIM_STATUS_SUCCESS",
  GET_ESIM_STATUS_FAILURE: "PRODUCTS/GET_ESIM_STATUS_FAILURE",

  // ESIM DATA SET
  SET_ESIM_STATUS_BEGINS: "PRODUCTS/SET_ESIM_STATUS_BEGINS",
  SET_ESIM_STATUS_SUCCESS: "PRODUCTS/SET_ESIM_STATUS_SUCCESS",
  SET_ESIM_STATUS_FAILURE: "PRODUCTS/SET_ESIM_STATUS_FAILURE",

  // CARDS R2R
  SET_R2R_CARDS: "PRODUCTS/SET_R2R_CARDS",

  // UPGRADE EQUIPMENT
  SET_UPGRADE_EQUIPMENT_BEGIN: "SET_UPGRADE_EQUIPMENT_BEGIN",
  SET_UPGRADE_EQUIPMENT_SUCCESS: "SET_UPGRADE_EQUIPMENT_SUCCESS",
  SET_UPGRADE_EQUIPMENT_ERROR: "SET_UPGRADE_EQUIPMENT_ERROR", 

  // FTTR PRODUCT R2R INFO
  GET_FTTR_PRODUCT_R2R_INFO_BEGIN: "GET_FTTR_PRODUCT_R2R_INFO_BEGIN",
  GET_FTTR_PRODUCT_R2R_INFO_SUCCESS: "GET_FTTR_PRODUCT_R2R_INFO_SUCCESS",
  GET_FTTR_PRODUCT_R2R_INFO_ERROR: "GET_FTTR_PRODUCT_R2R_INFO_ERROR", 
};

export const actions = {
  getMyProducts: (id) => ({ type: types.GET_MY_PRODUCTS_BEGINS, id }),
  getMyProductsSuccess: (products, bundleProduct, productsList) => ({
    type: types.GET_MY_PRODUCTS_SUCCESS,
    payload: { products, bundleProduct, productsList },
  }),
  getMyProductsFailure: (error) => ({
    type: types.GET_MY_PRODUCTS_FAILURE,
    payload: error,
  }),
  resetGetMyProducts: () => ({
    type: types.GET_MY_PRODUCTS_RESET,
  }),
  //WITHOUT CACHE 
  getMyProductsWithoutCache: (id) => ({ type: types.GET_MY_PRODUCTS_WITHOUT_CACHE_BEGINS, id }),
  getMyProductsWithoutCacheSuccess: (products, bundleProduct, productsList) => ({
    type: types.GET_MY_PRODUCTS_WITHOUT_CACHE_SUCCESS,
    payload: { products, bundleProduct, productsList },
  }),
  getMyProductsWithoutCacheFailure: (error) => ({
    type: types.GET_MY_PRODUCTS_WITHOUT_CACHE_FAILURE,
    payload: error,
  }),
  resetGetMyWithoutCacheProducts: () => ({
    type: types.GET_MY_PRODUCTS_WITHOUT_CACHE_RESET,
  }),

  setKindClient: (data) => ({ type: types.SET_KIND_CLIENT, payload: data }),
  // ENVIO GESTION DE LINEA MOVIL
  changeMobileConfiguration: (phone, diversionToChange, diversionPhone) => ({
    type: types.CHANGE_MOBILE_CONFIGURATION_BEGINS,
    phone,
    diversionToChange,
    diversionPhone,
  }),
  successChangeMobileConfiguration: () => ({
    type: types.CHANGE_MOBILE_CONFIGURATION_SUCCESS,
  }),
  errorChangeMobileConfiguration: (error) => ({
    type: types.CHANGE_MOBILE_CONFIGURATION_FAILURE,
    payload: error,
  }),
  resetChangeMobileConfiguration: () => ({
    type: types.RESET_CHANGE_MOBILE_CONFIGURATION,
  }),
  // GET MOBILE CONFIG
  getMobileConfigurationStatus: (phone, tipo) => ({
    type: types.GET_MOBILE_CONFIGURATION_STATUS_BEGINS,
    phone,
    tipo,
  }),
  successGetMobileConfigurationStatus: (configs) => ({
    type: types.GET_MOBILE_CONFIGURATION_STATUS_SUCCESS,
    payload: configs,
  }),
  errorGetMobileConfigurationStatus: () => ({
    type: types.GET_MOBILE_CONFIGURATION_STATUS_FAILURE,
  }),
  resetMobileConfigurationStatus: () => ({
    type: types.RESET_MOBILE_CONFIGURATION_STATUS,
  }),
  // GET MOBILE RESTRICTION
  getMyLineDetailMobileRestrictionStatus: (data) => ({
    type: types.GET_MY_LINE_DETAIL_MOBILE_RESTRICTION_STATUS_BEGINS,
    data: { ...data },
  }),
  successgetMyLineDetailMobileRestrictionStatus: (configs) => ({
    type: types.GET_MY_LINE_DETAIL_MOBILE_RESTRICTION_STATUS_SUCCESS,
    payload: configs,
  }),
  errorgetMyLineDetailMobileRestrictionStatus: () => ({
    type: types.GET_MY_LINE_DETAIL_MOBILE_RESTRICTION_STATUS_FAILURE,
  }),
  resetgetMyLineDetailMobileRestrictionStatus: (number) => ({
    type: types.RESET_MY_LINE_DETAIL_MOBILE_RESTRICTION_STATUS,
    payload: number,
  }),
  // Change Mobile Restriction
  changeMobileRestriction: (productId, restriction, action, phoneType, id) => ({
    type: types.CHANGE_MOBILE_RESTRICTION_BEGINS,
    productId,
    restriction,
    action,
    phoneType,
    id,
  }),
  successChangeMobileRestriction: () => ({
    type: types.CHANGE_MOBILE_RESTRICTION_SUCCESS,
  }),
  errorChangeMobileRestriction: (error) => ({
    type: types.CHANGE_MOBILE_RESTRICTION_FAILURE,
    payload: error,
  }),
  resetChangeMobileRestriction: () => ({
    type: types.RESET_CHANGE_MOBILE_RESTRICTION,
  }),
  // Change Mobile Restriction
  changeMobileRestrictionGestion: (data) => ({
    type: types.CHANGE_MOBILE_RESTRICTION_GESTION_BEGINS,
    ...data
  }),
  successChangeMobileRestrictionGestion: (configs) => ({
    type: types.CHANGE_MOBILE_RESTRICTION_GESTION_SUCCESS,
    payload: configs,
  }),
  errorChangeMobileRestrictionGestion: (error) => ({
    type: types.CHANGE_MOBILE_RESTRICTION_GESTION_FAILURE,
    payload: error,
  }),
  resetChangeMobileRestrictionGestion: () => ({
    type: types.RESET_CHANGE_MOBILE_GESTION_RESTRICTION,
  }),
  getMobileRestrictionStatus: (productId, phoneType, phone) => ({
    type: types.GET_MOBILE_RESTRICTION_STATUS_BEGINS,
    productId,
    phoneType,
    phone,
  }),
  successGetMobileRestrictionStatus: (configs) => ({
    type: types.GET_MOBILE_RESTRICTION_STATUS_SUCCESS,
    payload: configs,
  }),
  errorGetMobileRestrictionStatus: () => ({
    type: types.GET_MOBILE_RESTRICTION_STATUS_FAILURE,
  }),
  // FOR GESTIONS
  getMobileRestrictionGestionsStatus: (productId, phoneType, phone) => ({
    type: types.GET_MOBILE_RESTRICTION_GESTION_STATUS_BEGINS,
    productId,
    phoneType,
    phone,
  }),
  successGetMobileRestrictionGestionsStatus: (configs) => ({
    type: types.GET_MOBILE_RESTRICTION_GESTION_STATUS_SUCCESS,
    payload: configs,
  }),
  successGetMobileRestrictionGestionsStatusUpdate: (updateId) => ({
    type: types.GET_MOBILE_RESTRICTION_GESTION_STATUS_SUCCESS_UPDATE,
    payload: updateId,
  }),
  successGetMobileRestrictionGestionsMsgUpdate: (updateMsg) => ({
    type: types.GET_MOBILE_RESTRICTION_GESTION_MSG_SUCCESS_UPDATE,
    payload: updateMsg,
  }),
  errorGetMobileRestrictionGestionsStatus: () => ({
    type: types.GET_MOBILE_RESTRICTION_GESTION_STATUS_FAILURE,
  }),

  resetGetMobileRestrictionStatus: () => ({
    type: types.RESET_MOBILE_RESTRICTION_STATUS,
  }),
  resetAllGetMobileRestrictionStatus: () => ({
    type: types.RESET_ALL_MOBILE_RESTRICTION_STATUS,
  }),
  setPhoneType: (phoneType) => ({
    type: types.SET_PHONE_TYPE,
    payload: phoneType,
  }),
  // EQUIPMENT
  getEquipmentProducts: () => ({
    type: types.GET_EQUIPMENT_PRODUCTS,
  }),
  getEquipmentProductsSuccess: (data) => ({
    type: types.GET_EQUIPMENT_PRODUCTS_SUCCESS,
    payload: data,
  }),
  // R2R
  getIsR2rHired: ({ typeR2R }) => ({
    type: types.GET_MIS_PRODUCTOS_R2R_BEGINS,
    typeR2R,
  }),
  successGetIsR2rHired: (data) => ({
    type: types.GET_MIS_PRODUCTOS_R2R_SUCCESS,
    payload: data,
  }),
  errorGetIsR2rHired: (error) => ({
    type: types.GET_MIS_PRODUCTOS_R2R_FAILURE,
  }),
  getMyProductsR2R: () => ({
    type: types.GET_ALL_PRODUCTOS_R2R_BEGINS,
  }),
  getMyProductsR2RSuccess: () => ({
    type: types.GET_ALL_PRODUCTOS_R2R_SUCCESS,
  }),
  getActivateLine: (data) => ({
    type: types.GET_ACTIVATE_LINE_BEGINS,
    data,
  }),
  successGetActivateLine: (data) => ({
    type: types.GET_ACTIVATE_LINE_SUCCESS,
    payload: data,
  }),
  errorGetActivateLine: (error) => ({
    type: types.GET_ACTIVATE_LINE_FAILURE,
    payload: error,
  }),

  postSegundaFibraActivarBegins: (data) => ({
    type: types.POST_SEGUNDA_FIBRA_ACTIVAR_BEGINS,
    ...data,
  }),
  postSegundaFibraActivarSucess: (data) => ({
    type: types.POST_SEGUNDA_FIBRA_ACTIVAR_SUCCESS,
    payload: data,
  }),
  errorPostSegundaFibraActivar: (error) => ({
    type: types.POST_SEGUNDA_FIBRA_ACTIVAR_ERROR,
    payload: error,
  }),
  postSegundaFibraActivarReset: () => ({
    type: types.POST_SEGUNDA_FIBRA_ACTIVAR_RESET,
  }),
  postSegundaFibraDesactivarBegins: (data) => ({
    type: types.POST_SEGUNDA_FIBRA_DESACTIVAR_BEGINS,
    ...data,
  }),
  postSegundaFibraDesactivarSucess: (data) => ({
    type: types.POST_SEGUNDA_FIBRA_DESACTIVAR_SUCCESS,
    payload: data,
  }),
  errorPostSegundaFibraDesactivar: (error) => ({
    type: types.POST_SEGUNDA_FIBRA_DESACTIVAR_ERROR,
    payload: error,
  }),
  postSegundaFibraDesactivarReset: () => ({
    type: types.POST_SEGUNDA_FIBRA_DESACTIVAR_RESET,
  }),

  getSellingTypesByProductIds: (data) => ({
    type: types.GET_SELLING_TYPES_BY_PRODUCT_ID_BEGIN,
    payload: data,
  }),
  successGetSellingTypesByProductId: (data) => ({
    type: types.GET_SELLING_TYPES_BY_PRODUCT_ID_SUCCESS,
    payload: data,
  }),
  statusGetSellingTypesByProductId: (error) => ({
    type: types.GET_SELLING_TYPES_BY_PRODUCT_ID_STATUS,
    payload: error,
  }),
  resetGetSellingTypesByProductIds: () => ({
    type: types.GET_SELLING_TYPES_BY_PRODUCT_ID_STATUS_RESET,
  }),
  successGetImageDevices: (data) => ({
    type: types.GET_IMAGES_RENT2RENT,
    payload: data,
  }),
  //PUK CODE
  getPukCode: (productId) => ({
    type: types.GET_PUK_CODE_BEGINS,
    productId,
  }),
  successGetPukCode: data => ({
    type: types.GET_PUK_CODE_SUCCESS,
    payload: data,
  }),
  errorGetPukCode: error => ({
    type: types.GET_PUK_CODE_FAILURE,
    payload: error,
  }),

  getEsimDownload: (resourceId) => ({ type: types.GET_ESIM_DOWNLOAD_BEGINS, resourceId }),
  getEsimDownloadSuccess: (esimDownloadInfo) => ({
    type: types.GET_ESIM_DOWNLOAD_SUCCESS,
    payload: { esimDownloadInfo },
  }),
  getEsimDownloadFailure: (error) => ({
    type: types.GET_ESIM_DOWNLOAD_FAILURE,
    payload: error,
  }),
  getEsimStatus: (handlingCode, productId, typeEsim, status) => ({ type: types.GET_ESIM_STATUS_BEGINS,handlingCode, productId, typeEsim, status }),
  getEsimStatusSuccess: ({esimStatusInfo, esimStatus,resourceDataSelected}) => ({
    type: types.GET_ESIM_STATUS_SUCCESS,
    payload: { esimStatusInfo, esimStatus,resourceDataSelected },
  }),
  getEsimStatusFailure: (error) => ({
    type: types.GET_ESIM_STATUS_FAILURE,
    payload: error,
  }),
  // ESIM STATUS
  resourceDataSelected:null,
  resourceIdSelected:null,
  setEsimStatus: ({esimStatus,resourceDataSelected}) => ({ type: types.SET_ESIM_STATUS_BEGINS, esimStatus,resourceDataSelected }),
  setEsimStatusSuccess: ({esimStatus,resourceDataSelected}) => ({
    type: types.SET_ESIM_STATUS_SUCCESS,
    payload: { esimStatus,resourceDataSelected },
  }),
  setEsimStatusFailure: (error) => ({
    type: types.SET_ESIM_STATUS_FAILURE,
    payload: error,
  }),
  // CARDS R2R  
  setR2RCards: (cards) => ({ type: types.SET_R2R_CARDS, payload: cards }),
  // UPGRADE EQUIPMENT
  getUpgradeEquipment: (data) => ({ type: types.SET_UPGRADE_EQUIPMENT_BEGIN, payload: data }),
  getUpgradeEquipmentSuccess: (data) => ({ type: types.SET_UPGRADE_EQUIPMENT_SUCCESS, payload: data }),
  getUpgradeEquipmentError: (error) => ({ type: types.SET_UPGRADE_EQUIPMENT_ERROR, payload: error }),
  // FTTR INFO
  getFttrInfo: ({ typeR2R }) => ({
    type: types.GET_FTTR_PRODUCT_R2R_INFO_BEGIN,
    typeR2R,
  }),
  successGetFttrInfo: (data) => ({
    type: types.GET_FTTR_PRODUCT_R2R_INFO_SUCCESS,
    payload: data,
  }),
  errorGetFttrInfo: () => ({
    type: types.GET_FTTR_PRODUCT_R2R_INFO_ERROR,
  }),
};

const initialState = {
  hiredProducts: [],
  hiredProductsList: [],
  productsError: false,
  isProductsFetching: false,
  isProductsFetched: false,
  numberOfProducts: null,
  kindProduct: null,
  bundleProduct: null,

  hiredProductsNoCache: [],
  hiredProductsListNoCache: [],
  productsErrorNoCache: false,
  isProductsFetchingNoCache: false,
  isProductsFetchedNoCache: false,
  numberOfProductsNoCache: null,
  kindProductNoCache: null,
  bundleProductNoCache: null,

  currentMobilePid: null,
  phoneType: null,
  myLineDetailMobileRestrictionStatusFetched: false,
  myLineDetailMobileRestrictionStatusFetching: false,
  myLineDetailMobileRestrictionStatusError: false,
  myLineDetailMobileRestrictionStatus: null,
  // MOBILE CONFIG
  currentMobilePid: null,
  mobileConfigurationStatusFetching: false,
  mobileConfigurationStatusFetched: false,
  mobileConfigurationStatus: null,
  mobileConfigurationStatusError: false,
  // MOBILE POST CONFIG
  changeMobileConfigurationFetching: false,
  changeMobileConfiguration: null,
  changeMobileConfigurationError: false,
  // MOBILE POST RESTRICTION
  mobileRestrictionStatusFetching: false,
  mobileRestrictionStatusFetched: false,
  mobileRestrictionStatus: null,
  mobileRestrictionStatusError: false,

  //ACTIVE/INACTIVE RESTRICTIONS
  mobileRestrictionGestionsStatusFetching: false,
  mobileRestrictionGestionsStatusFetched: false,
  mobileRestrictionGestionsStatus: null,
  mobileRestrictionGestionsStatusError: false,
  mobileRestrictionGestionsStatusId: null,
  mobileRestrictionGestionsMsgUpdate: "",

  phoneType: "movil",
  changeMobileRestrictionFetching: false,
  changeMobileRestriction: null,
  changeMobileRestrictionError: false,
  //GESTION LINEAS GESTION ROAMING
  changeMobileRestrictionGestionFetching: false,
  changeMobileRestrictionGestion: null,
  changeMobileRestrictionGestionError: false,
  // EQUIPMENT
  equipment: null,
  equipmentFetching: false,
  // R2R
  myProductR2RType: null,
  myProductR2RFetchedType: null,
  myProductR2RFetching: false,
  myProductR2RFetched: false,
  myProductR2R: null,
  myProductR2RError: false,
  imagesR2R: null,
  cardsR2R: null,
  hasApple: false,
  numberDevices: null,
  myAllProductR2RInfoFetching: false,
  // ACTIVATE LINE
  activateLineFetching: false,
  activateLineData: null,
  activateLineError: false,

  //segunda fibra
  segundaFibraActivarStatus: false,
  segundaFibraActivar: null,
  segundaFibraActivarError: false,
  segundaFibraDesactivarStatus: false,
  segundaFibraDesactivar: null,
  segundaFibraDesactivarError: false,
  sellingTypesByProductId: null,
  sellingTypesByProductIdStatus: false,
  //PUK CODE
  pukCode: null,
  pukCodeFetching:false,
  pukCodeError:false,

  // ESIM DOWNLOAD 
  esimDownloadInfo:null,
  esimDownloadFetching:null,
  esimDownloadError:null,

  // ESIM STATUS 
  esimStatusInfo: [],
  esimStatusFetching:null,
  esimStatusError:null,
  esimStatus:'Fake',
  resourceDataSelected:null,
  resourceIdSelected:null,

  //UPGRADE EQUIPMENT
  upgradeEquipment: null,
  upgradeEquipmentFetching: null,
  upgradeEquipmentError: null,

  //FTTR
  fttrInfo: null,
  fttrInfoFetching: null,
  fttrInfoError: null,
};
function reducer(
  state = { ...initialState },
  { type, payload, phoneType, productId }
) {
  switch (type) {
    case HYDRATE: {
      const { product } = payload;
      return {
        ...state,
        ...product,
      };
    }
    case types.GET_MY_PRODUCTS_BEGINS:
      return {
        ...state,
        hiredProducts: [],
        hiredProductsList: [],
        productsError: false,
        isProductsFetching: true,
        isProductsFetched: false,
        numberOfProducts: null,
        bundleProduct: null,
      };
    case types.GET_MY_PRODUCTS_SUCCESS: {
      const { products, bundleProduct, productsList } = payload;
      return {
        ...state,
        hiredProducts: products,
        hiredProductsList: productsList,
        productsError: false,
        isProductsFetching: false,
        isProductsFetched: true,
        numberOfProducts: products.length,
        bundleProduct,
      };
    }
    case types.GET_MY_PRODUCTS_FAILURE:
      return {
        ...state,
        hiredProducts: [],
        hiredProductsList: [],
        productsError: payload,
        isProductsFetching: false,
        isProductsFetched: false,
        numberOfProducts: null,
        bundleProduct: false,
      };
    case types.GET_MY_PRODUCTS_RESET:
      return {
        ...state,
        hiredProducts: [],
        hiredProductsList: [],
        productsError: false,
        isProductsFetching: false,
        isProductsFetched: false,
        numberOfProducts: null,
        kindProduct: null,
        bundleProduct: null,
      };

      case types.GET_MY_PRODUCTS_WITHOUT_CACHE_BEGINS:
        return {
          ...state,
          hiredProductsNoCache: [],
          hiredProductsListNoCache: [],
          productsErrorNoCache: false,
          isProductsFetchingNoCache: true,
          isProductsFetchedNoCache: false,
          numberOfProductsNoCache: null,
          bundleProductNoCache: null,
        };
      case types.GET_MY_PRODUCTS_WITHOUT_CACHE_SUCCESS: {
        const { products, bundleProduct, productsList } = payload;
        return {
          ...state,
          hiredProductsNoCache: products,
          hiredProductsListNoCache: productsList,
          productsErrorNoCache: false,
          isProductsFetchingNoCache: false,
          isProductsFetchedNoCache: true,
          numberOfProductsNoCache: products.length,
          bundleProductNoCache: bundleProduct,
        };
      }
      case types.GET_MY_PRODUCTS_WITHOUT_CACHE_FAILURE:
        return {
          ...state,
          hiredProductsNoCache: [],
          hiredProductsListNoCache: [],
          productsErrorNoCache: payload,
          isProductsFetchingNoCache: false,
          isProductsFetchedNoCache: false,
          numberOfProductsNoCache: null,
          bundleProductNoCache: false,
        };
      case types.GET_MY_PRODUCTS_WITHOUT_CACHE_RESET:
        return {
          ...state,
          hiredProductsNoCache: [],
          hiredProductsListNoCache: [],
          productsErrorNoCache: false,
          isProductsFetchingNoCache: false,
          isProductsFetchedNoCache: false,
          numberOfProductsNoCache: null,
          bundleProductNoCache: null,
          kindProductNoCache: null,
        };

    case types.SET_KIND_CLIENT:
      return { ...state, kindProduct: payload };
    case types.GET_MY_LINE_DETAIL_MOBILE_RESTRICTION_STATUS_BEGINS: {
      let phoneTypeState = state.phoneType;
      if (phoneType) {
        phoneTypeState = phoneType;
      }
      return {
        ...state,
        currentMobilePid: productId,
        myLineDetailMobileRestrictionStatusFetched: false,
        myLineDetailMobileRestrictionStatusFetching: true,
        myLineDetailMobileRestrictionStatusError: false,
        phoneType: phoneTypeState,
      };
    }
    case types.GET_MY_LINE_DETAIL_MOBILE_RESTRICTION_STATUS_SUCCESS: {
      let newMobileRestrictionStatusData =
        state.myLineDetailMobileRestrictionStatus;
      if (payload) {
        newMobileRestrictionStatusData = {
          ...newMobileRestrictionStatusData,
          ...payload,
        };
      }
      return {
        ...state,
        myLineDetailMobileRestrictionStatusFetching: false,
        myLineDetailMobileRestrictionStatusFetched: true,
        myLineDetailMobileRestrictionStatus: newMobileRestrictionStatusData,
        myLineDetailMobileRestrictionStatusError: false,
      };
    }

    case types.GET_MY_LINE_DETAIL_MOBILE_RESTRICTION_STATUS_FAILURE:
      return {
        ...state,
        myLineDetailMobileRestrictionStatusFetching: false,
        myLineDetailMobileRestrictionStatusError: true,
      };

    case types.RESET_MY_LINE_DETAIL_MOBILE_RESTRICTION_STATUS: {
      return {
        ...state,
        currentMobilePid: null,
        myLineDetailMobileRestrictionStatusFetched: false,
        myLineDetailMobileRestrictionStatusFetching: false,
        myLineDetailMobileRestrictionStatusError: false,
        myLineDetailMobileRestrictionStatus: null,
        phoneType: null,
      };
    }
    // GET MOBILE CONFIG
    case types.GET_MOBILE_CONFIGURATION_STATUS_BEGINS:
      return {
        ...state,
        currentMobilePid: productId,
        mobileConfigurationStatusFetched: false,
        mobileConfigurationStatusFetching: true,
        mobileConfigurationStatusError: false,
      };
    case types.GET_MOBILE_CONFIGURATION_STATUS_SUCCESS: {
      let newMobileConfigurationStatusData = state.mobileConfigurationStatus;
      if (payload) {
        newMobileConfigurationStatusData = {
          ...newMobileConfigurationStatusData,
          ...payload,
        };
      }
      return {
        ...state,
        mobileConfigurationStatusFetched: true,
        mobileConfigurationStatusFetching: false,
        mobileConfigurationStatus: newMobileConfigurationStatusData,
        mobileConfigurationStatusError: false,
      };
    }
    case types.GET_MOBILE_CONFIGURATION_STATUS_FAILURE:
      return {
        ...state,
        mobileConfigurationStatusFetching: false,
        mobileConfigurationStatusError: true,
      };
    case types.CHANGE_MOBILE_CONFIGURATION_BEGINS: {
      return {
        ...state,
        changeMobileConfigurationFetching: true,
        changeMobileConfigurationError: false,
      };
    }
    case types.CHANGE_MOBILE_CONFIGURATION_SUCCESS: {
      return {
        ...state,
        changeMobileConfiguration: true,
        changeMobileConfigurationFetching: false,
        changeMobileConfigurationError: false,
      };
    }
    case types.CHANGE_MOBILE_CONFIGURATION_FAILURE:
      return {
        ...state,
        changeMobileConfiguration: payload,
        changeMobileConfigurationFetching: false,
        changeMobileConfigurationError: true,
      };
    case types.RESET_CHANGE_MOBILE_CONFIGURATION:
      return {
        ...state,
        changeMobileConfiguration: null,
        changeMobileConfigurationFetching: false,
        changeMobileConfigurationError: null,
      };
      case types.CHANGE_MOBILE_RESTRICTION_BEGINS: {
        return {
          ...state,
          changeMobileRestrictionFetching: true,
          changeMobileRestrictionError: false,
        };
      }
      case types.CHANGE_MOBILE_RESTRICTION_SUCCESS: {
        return {
          ...state,
          changeMobileRestriction: true,
          changeMobileRestrictionFetching: false,
          changeMobileRestrictionError: false,
        };
      }
      case types.CHANGE_MOBILE_RESTRICTION_FAILURE:
        return {
          ...state,
          changeMobileRestriction: payload,
          changeMobileRestrictionFetching: false,
          changeMobileRestrictionError: true,
        };
      case types.RESET_CHANGE_MOBILE_RESTRICTION:
        return {
          ...state,
          changeMobileRestriction: null,
          changeMobileRestrictionFetching: false,
          changeMobileRestrictionError: null,
        };
      //GESTION LINEAS ROAMING
      case types.CHANGE_MOBILE_RESTRICTION_GESTION_BEGINS: {
        return {
          ...state,
          changeMobileRestrictionGestionFetching: true,
          changeMobileRestrictionGestionError: false,
        };
      }
      case types.CHANGE_MOBILE_RESTRICTION_GESTION_SUCCESS: {
        return {
          ...state,
          changeMobileRestrictionGestion: true,
          changeMobileRestrictionGestionFetching: false,
          changeMobileRestrictionGestionError: false,
        };
      }
      case types.CHANGE_MOBILE_RESTRICTION_GESTION_FAILURE:
        return {
          ...state,
          changeMobileRestrictionGestion: payload,
          changeMobileRestrictionGestionFetching: false,
          changeMobileRestrictionGestionError: true,
        };
      case types.RESET_CHANGE_MOBILE_GESTION_RESTRICTION:
        return {
          ...state,
          changeMobileRestrictionGestion: null,
          changeMobileRestrictionGestionFetching: false,
          changeMobileRestrictionGestionError: null,
        };
    case types.GET_MOBILE_RESTRICTION_STATUS_BEGINS: {
      let phoneTypeState = state.phoneType;
      if (phoneType) {
        phoneTypeState = phoneType;
      }
      return {
        ...state,
        currentMobilePid: productId,
        mobileRestrictionStatusFetched: false,
        mobileRestrictionStatusFetching: true,
        mobileRestrictionStatusError: false,
        phoneType: phoneTypeState,
      };
    }
    case types.GET_MOBILE_RESTRICTION_STATUS_SUCCESS: {
      let newMobileRestrictionStatusData = state.mobileRestrictionStatus;
      if (payload) {
        newMobileRestrictionStatusData = {
          ...newMobileRestrictionStatusData,
          ...payload,
        };
      }
      return {
        ...state,
        mobileRestrictionStatusFetching: false,
        mobileRestrictionStatusFetched: true,
        mobileRestrictionStatus: newMobileRestrictionStatusData,
        mobileRestrictionStatusError: false,
      };
    }
    case types.GET_MOBILE_RESTRICTION_STATUS_FAILURE: {
      return {
        ...state,
        mobileRestrictionStatusFetching: false,
        mobileRestrictionStatusError: true,
      };
    }


    //GESTIONS

    


case types.GET_MOBILE_RESTRICTION_GESTION_STATUS_BEGINS: {
  let phoneTypeState = state.phoneType;
  if (phoneType) {
    phoneTypeState = phoneType;
  }
  



  return {
    ...state,
    currentMobilePid: productId,
    mobileRestrictionGestionsStatusFetched: false,
    mobileRestrictionGestionsStatusFetching: true,
    mobileRestrictionGestionsStatusError: false,
    phoneType: phoneTypeState,
  };
}
case types.GET_MOBILE_RESTRICTION_GESTION_STATUS_SUCCESS: {
  let newMobileRestrictionStatusData = state.mobileRestrictionGestionsStatus;
  if (payload) {
    newMobileRestrictionStatusData = {
      ...newMobileRestrictionStatusData,
      ...payload,
    };
  }
  return {
    ...state,
    mobileRestrictionGestionsStatusFetching: false,
    mobileRestrictionGestionsStatusFetched: true,
    mobileRestrictionGestionsStatus: newMobileRestrictionStatusData,
    mobileRestrictionGestionsStatusError: false,
  };
}
case types.GET_MOBILE_RESTRICTION_GESTION_STATUS_SUCCESS_UPDATE: {
  const { updateId } = payload;
  return {
    ...state,
    mobileRestrictionGestionsStatusId:updateId
  };
}
case types.GET_MOBILE_RESTRICTION_GESTION_MSG_SUCCESS_UPDATE: {
  return {
    ...state,
    mobileRestrictionGestionsMsgUpdate:payload
  };
}


case types.GET_MOBILE_RESTRICTION_GESTION_STATUS_FAILURE: {
  return {
    ...state,
    mobileRestrictionGestionsStatusFetching: false,
    mobileRestrictionGestionsStatusError: true,
  };
}




    case types.RESET_MOBILE_CONFIGURATION_STATUS: {
      return {
        ...state,
        mobileConfigurationStatus: null,
        mobileConfigurationStatusFetching: false,
        mobileConfigurationStatusError: false,
      };
    }
    case types.RESET_CHANGE_MOBILE_RESTRICTION: {
      const newMobileRestrictionStatus = state.mobileRestrictionStatus;
      newMobileRestrictionStatus[payload] = null;
      return {
        ...state,
        mobileRestrictionStatus: newMobileRestrictionStatus,
        mobileRestrictionStatusFetched: false,
        mobileRestrictionStatusError: false,
      };
    }
    case types.RESET_ALL_MOBILE_RESTRICTION_STATUS: {
      return {
        ...state,
        mobileConfigurationStatusError: false,
      };
    }
    case types.SET_PHONE_TYPE: {
      return {
        ...state,
        phoneType: payload,
      };
    }
    // EQUIPMENT
    case types.GET_EQUIPMENT_PRODUCTS: {
      return {
        ...state,
        equipmentFetching: true,
      };
    }
    case types.GET_EQUIPMENT_PRODUCTS_SUCCESS: {
      return {
        ...state,
        equipment: payload,
        equipmentFetching: false,
      };
    }
    // R2R
    case types.GET_MIS_PRODUCTOS_R2R_BEGINS:
      return {
        ...state,
        myProductR2RType: payload,
        myProductR2RFetching: true,
        myProductR2RFetched: false,
        myProductR2R: state.myProductR2R,
        myProductR2RError: false,
      };
    case types.GET_MIS_PRODUCTOS_R2R_SUCCESS: {
      const productosRentToRent = payload;
      const lastDataMyProductR2R = {
        ...state.myProductR2R,
      };
      const lastKeys = Object.keys(lastDataMyProductR2R);
      if (
        Array.isArray(productosRentToRent) &&
        productosRentToRent.length > 0
      ) {
        const exist = lastKeys.find(
          (elem) => elem === productosRentToRent[0].typeR2R
        );
        if (!exist) {
          lastDataMyProductR2R[productosRentToRent[0].typeR2R] = payload;
        }
      }

      // Para determinar que tipo de r2r se ha obtenido (incluido/adicional/ambos)
      let fetchedType = state.myProductR2RType;
      if (
        state.myProductR2RFetchedType !== null &&
        state.myProductR2RFetchedType !== state.myProductR2RType
      ) {
        fetchedType = "both";
      }

      return {
        ...state,
        myProductR2RFetchedType: fetchedType,
        myProductR2RFetching: false,
        myProductR2RFetched: true,
        myProductR2R: lastDataMyProductR2R,
        myProductR2RError: false,
      };
    }
    case types.GET_MIS_PRODUCTOS_R2R_FAILURE:
      return {
        ...state,
        myProductR2RFetching: false,
        myProductR2RFetched: false,
        myProductR2R: payload,
        myProductR2RError: true,
      };
    // ACTIVATE LINE
    case types.GET_ACTIVATE_LINE_BEGINS: {
      return {
        ...state,
        activateLineFetching: true,
        activateLineError: false,
      };
    }
    case types.GET_ACTIVATE_LINE_SUCCESS: {
      return {
        ...state,
        activateLineFetching: false,
        activateLineData: payload,
        activateLineError: false,
      };
    }
    case types.GET_ACTIVATE_LINE_FAILURE:
      return {
        ...state,
        activateLineFetching: false,
        activateLineData: null,
        activateLineError: true,
      };

    case types.POST_SEGUNDA_FIBRA_ACTIVAR_BEGINS:
      return {
        ...state,
        segundaFibraActivarStatus: "LOADING",
        segundaFibraActivar: null,
        segundaFibraActivarError: null,
      };
    case types.POST_SEGUNDA_FIBRA_ACTIVAR_SUCCESS:
      return {
        ...state,
        segundaFibraActivarStatus: "LOADED",
        segundaFibraActivar: payload,
        segundaFibraActivarError: false,
      };
    case types.POST_SEGUNDA_FIBRA_ACTIVAR_ERROR:
      return {
        ...state,
        segundaFibraActivarStatus: "ERROR",
        segundaFibraActivar: null,
        segundaFibraActivarError: payload,
      };
    case types.POST_SEGUNDA_FIBRA_ACTIVAR_RESET:
      return {
        ...state,
        segundaFibraActivarStatus: "",
        segundaFibraActivar: null,
        segundaFibraActivarError: null,
      };
    case types.POST_SEGUNDA_FIBRA_DESACTIVAR_BEGINS:
      return {
        ...state,
        segundaFibraDesactivarStatus: "LOADING",
        segundaFibraDesactivar: null,
        segundaFibraDesactivarError: null,
      };
    case types.POST_SEGUNDA_FIBRA_DESACTIVAR_SUCCESS:
      return {
        ...state,
        segundaFibraDesactivarStatus: "LOADED",
        segundaFibraDesactivar: payload,
        segundaFibraDesactivarError: false,
      };
    case types.POST_SEGUNDA_FIBRA_DESACTIVAR_ERROR:
      return {
        ...state,
        segundaFibraDesactivarStatus: "ERROR",
        segundaFibraDesactivar: null,
        segundaFibraDesactivarError: payload,
      };
    case types.POST_SEGUNDA_FIBRA_DESACTIVAR_RESET:
      return {
        ...state,
        segundaFibraDesactivarStatus: "",
        segundaFibraDesactivar: null,
        segundaFibraDesactivarError: null,
      };

    case types.GET_SELLING_TYPES_BY_PRODUCT_ID_BEGIN: {
      return {
        ...state,
        sellingTypesByProductIdStatus: "FETCHING",
      };
    }
    case types.GET_SELLING_TYPES_BY_PRODUCT_ID_SUCCESS: {
      return {
        ...state,
        sellingTypesByProductId: payload,
        sellingTypesByProductIdStatus: "OK",
      };
    }
    case types.GET_SELLING_TYPES_BY_PRODUCT_ID_STATUS: {
      return {
        ...state,
        sellingTypesByProductIdStatus: payload,
      };
    }

    case types.GET_SELLING_TYPES_BY_PRODUCT_ID_STATUS_RESET:
      return {
        ...state,
        sellingTypesByProductId: null,
        sellingTypesByProductIdStatus: false,
      };
    case types.GET_IMAGES_RENT2RENT:
      let newModule = {
        ...state.imagesR2R,
      };
      const {name, image, idPO} = payload;
      newModule[idPO] = {name, image, idPO}
      return {
        ...state,
        imagesR2R: newModule
      };
    // GET PUK CODE
    case types.GET_PUK_CODE_BEGINS: {
      return {
        ...state,
        pukCode: null,
        pukCodeFetching: true,
        pukCodeError: false,
      };
    }
    case types.GET_PUK_CODE_SUCCESS: {
      const pukData = payload;
      const lastDataPuk = {
        ...state.pukCode,
      };
      const lastKeys = Object.keys(lastDataPuk);
      const exist = lastKeys.find((elem) => elem === pukData.productId);
      if (!exist) {
        lastDataPuk[pukData.productId] = payload;
      }
      return {
        ...state,
        pukCode: lastDataPuk,
        pukCodeFetching: false,
        pukCodeError: false,
      };
    }
  case types.GET_PUK_CODE_FAILURE:
    return {
      ...state,
      pukCodeFetching: false,
      pukCodeError: true,
    };

  //ESIM DOWNLOAD
  case types.GET_ESIM_DOWNLOAD_BEGINS:
    return {
      ...state,
      esimDownloadError: false,
      esimDownloadFetching: true,
      esimDownloadInfo: null,
    };
  case types.GET_ESIM_DOWNLOAD_SUCCESS: {
    const { esimDownloadInfo } = payload;
    return {
      ...state,
      esimDownloadError: false,
      esimDownloadFetching: false,
      esimDownloadInfo,
    };
  }
  case types.GET_ESIM_DOWNLOAD_FAILURE:
    return {
      ...state,
      esimDownloadError: payload,
      esimDownloadFetching: false,
      esimDownloadInfo: null,
    };



  // ESIM STATUS
  case types.GET_ESIM_STATUS_BEGINS:
    return {
      ...state,
      esimStatusError: false,
      esimStatusFetching: true,
      esimStatusInfo: null,
    };
  case types.GET_ESIM_STATUS_SUCCESS: {
    const { esimStatusInfo, esimStatus, resourceDataSelected } = payload;  
    return {
      ...state,
      esimStatusError: false,
      esimStatusFetching: false,
      esimStatusInfo,
      esimStatus,
      resourceDataSelected
    };
  }
  case types.GET_ESIM_STATUS_FAILURE:
    return {
      ...state,
      esimStatusError: payload,
      esimStatusFetching: false,
      esimStatusInfo: null,
    };

    //ESIM DOWNLOAD
    case types.GET_ESIM_DOWNLOAD_BEGINS:
      return {
        ...state,
        esimDownloadError: false,
        esimDownloadFetching: true,
        esimDownloadInfo: null,
      };
    case types.GET_ESIM_DOWNLOAD_SUCCESS: {
      const { esimDownloadInfo } = payload;
      return {
        ...state,
        esimDownloadError: false,
        esimDownloadFetching: false,
        esimDownloadInfo,
      };
    }
    case types.GET_ESIM_DOWNLOAD_FAILURE:
      return {
        ...state,
        esimDownloadError: payload,
        esimDownloadFetching: false,
        esimDownloadInfo: null,
      };
    
      //set ESIM STATUS
  case types.SET_ESIM_STATUS_BEGINS:
    return {
      ...state,
      esimStatusError: false,
      esimStatusFetching: true,
    };
  case types.SET_ESIM_STATUS_SUCCESS: {
    const { esimStatus,resourceDataSelected  } = payload;

    let page = getEsimContainerById(esimStatus)
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('page', page);

    if (resourceDataSelected?.productId) {
      currentUrl.searchParams.set('productId', resourceDataSelected.productId);
    } 

    window.history.pushState(null, '', currentUrl.toString());

    return {
      ...state,
      esimStatusError: false,
      esimStatusFetching: false,
      esimStatus,
      resourceDataSelected,
      resourceIdSelected:resourceDataSelected?.resourceId,
    };
  }
  case types.SET_ESIM_STATUS_FAILURE:
    return {
      ...state,
      esimStatusError: payload,
      esimStatusFetching: false,
      esimStatusInfo: null,
    };
  case types.SET_R2R_CARDS:
    const { cards, hasApple, numberDevices } = payload;
    return {
      ...state,
      cardsR2R: cards,
      hasApple: hasApple,
      numberDevices: numberDevices,
    }
  case types.GET_ALL_PRODUCTOS_R2R_BEGINS:
    return {
      ...state,
      myAllProductR2RInfoFetching: true,
    }
    case types.GET_ALL_PRODUCTOS_R2R_SUCCESS:
      return {
        ...state,
        myAllProductR2RInfoFetching: false,
      }
  // UPGRADE EQUIPMENT
  case types.SET_UPGRADE_EQUIPMENT_BEGIN:
    return {
      ...state,
      upgradeEquipmentFetching: true,
  }
  case types.SET_UPGRADE_EQUIPMENT_SUCCESS:
    return {
      ...state,
      upgradeEquipment: payload,
      upgradeEquipmentFetching: false,
  }
  case types.SET_UPGRADE_EQUIPMENT_ERROR:
    return {
      ...state,
      upgradeEquipmentFetching: false,
      upgradeEquipmentError: true,
  }
  // FTTR
  case types.GET_FTTR_PRODUCT_R2R_INFO_BEGIN:
    return {
      ...state,
      fttrInfoFetching: true,
  }
  case types.GET_FTTR_PRODUCT_R2R_INFO_SUCCESS:
    return {
      ...state,
      fttrInfo: payload,
      fttrInfoFetching: false,
  }
  case types.GET_FTTR_PRODUCT_R2R_INFO_ERROR:
    return {
      ...state,
      fttrInfoFetching: false,
      fttrInfoError: true,
  }
  default:
      return {
        ...state,
      };
  }
}

export default reducer;
